// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28skU","delete":"styles_delete__1l6lU","update":"styles_update__AZzKk","add":"styles_add__30gSc"};